export const startPolling = ({
    pollingFunction,
    onSuccess,
    onTimeout,
    onError,
    timeout = 60000,
    interval = 2000,
    onWindowClose,
    windowRef,
}) => {
    const startTime = Date.now();

    const pollInterval = setInterval(async () => {
        try {
            if (windowRef && windowRef.closed) {
                if (onWindowClose) {
                    onWindowClose();
                }
                clearInterval(pollInterval);
                return;
            }

            const elapsedTime = Date.now() - startTime;
            if (elapsedTime > timeout) {
                if (onTimeout) {
                    onTimeout();
                }
                clearInterval(pollInterval);
                return;
            }

            const result = await pollingFunction();
            if (result) {
                if (onSuccess) {
                    onSuccess();
                }
                clearInterval(pollInterval);
            }
        } catch (error) {
            if (onError) {
                onError(error);
            }
            clearInterval(pollInterval);
        }
    }, interval);
};
